// Размерът на номера на масата в плота (в пиксели на екрана).

// Средната ширина на удебелен знак (главни букви и цифри в system-ui/Helvetica)
// в em — с малко запас, за да не се допира до ръба.
const BOLD_CHAR_EM = 0.7;
// Хоризонталните отстъпи на реда с номера (px-0.5 от двете страни).
const NAME_PADDING_PX = 4;
// Под толкова пиксела номерът не се смалява — по-дълъг от плота прелива
// върху столовете, но не се реже с „…".
export const MIN_NAME_PX = 8;

/**
 * Колко голям да е номерът: дизайнерският размер (`maxSize`), смален така,
 * че целият номер да влезе в плота. Кръглата маса е по-тясна там, където
 * стои номерът (над центъра), затова ползва по-малка част от ширината.
 */
export const tableNameFontSize = ({
  name,
  plateWidth,
  isRound,
  maxSize,
}: {
  name: string;
  // Ширината на плота в пиксели на екрана.
  plateWidth: number;
  isRound: boolean;
  maxSize: number;
}) => {
  const room = plateWidth * (isRound ? 0.8 : 0.9) - NAME_PADDING_PX;
  const fitting = room / (Math.max(1, name.length) * BOLD_CHAR_EM);
  return Math.max(MIN_NAME_PX, Math.min(maxSize, fitting));
};
